// Kho bài viết "Công nghệ số dành cho giáo viên" (tĩnh, dễ thêm bài: thêm 1 object vào ARTICLES).
// Mỗi bài có thể gắn 1 "quà" (giftSlug) — nút tải dẫn tới /qua/<giftSlug> (đăng nhập để nhận + thu lead).

export type Block =
  | { t: 'p'; c: string }
  | { t: 'h2'; c: string }
  | { t: 'callout'; c: string; kind?: 'tip' | 'warn' | 'note' }
  | { t: 'code'; c: string }
  | { t: 'list'; items: string[] }
  | { t: 'steps'; items: { title: string; desc: string }[] }

export interface TechArticle {
  slug: string
  title: string
  category: string
  tag: string          // nhãn ngắn hiển thị trên thẻ
  readMin: number
  emoji: string
  excerpt: string
  giftSlug?: string     // nối tới GiftKeyword (nút "Nhận tài liệu")
  giftLabel?: string
  blocks: Block[]
}

export const ARTICLES: TechArticle[] = [
  {
    slug: 'gpt-soan-ke-hoach-bai-day',
    title: 'Dùng ChatGPT (GPT Work) soạn Kế hoạch bài dạy — lồng năng lực số & STEM đúng cách',
    category: 'AI cho giáo viên',
    tag: 'AI · KHBD',
    readMin: 7,
    emoji: '🧠',
    excerpt:
      'Không phải bảo AI "viết giáo án hộ" rồi chép. Đây là quy trình 6 bước biến ChatGPT thành trợ giảng bám đúng CV 5512, có mạch năng lực số và STEM — bạn giữ quyền kiểm soát chuyên môn.',
    giftSlug: 'gpt-khbd',
    giftLabel: 'Bộ prompt & khung KHBD (Word)',
    blocks: [
      { t: 'p', c: 'Nhiều thầy cô thử bảo ChatGPT "viết giáo án bài này" rồi thất vọng vì kết quả chung chung, không đúng cấu trúc, thiếu mạch năng lực số. Vấn đề không nằm ở AI — mà ở cách giao việc. Bài này chia sẻ quy trình mình dùng để AI dựng khung Kế hoạch bài dạy (KHBD) đúng CV 5512, có lồng năng lực số và STEM, còn thầy cô chỉ tinh chỉnh phần "hồn".' },

      { t: 'h2', c: 'Vì sao nên để AI dựng KHUNG, không phải viết hộ' },
      { t: 'p', c: 'Phần Mục tiêu – Tiến trình của KHBD tốn thời gian nhất nhưng lại là phần "khung" ai cũng viết na ná. Đây đúng là việc AI làm nhanh và ổn định. Ngược lại, ngữ liệu địa phương, thí nghiệm cụ thể, câu hỏi dẫn dắt — là chuyên môn của thầy cô, giữ lại.' },
      { t: 'callout', kind: 'tip', c: 'Nguyên tắc vàng: AI lo phần LẶP LẠI (khung, định dạng, gợi ý); giáo viên giữ phần SÁNG TẠO (ngữ liệu, tình huống, đánh giá).' },

      { t: 'h2', c: 'Quy trình 6 bước' },
      {
        t: 'steps', items: [
          { title: 'Tạo một "Project" trợ giảng', desc: 'Trong ChatGPT (hoặc Claude), tạo Project "KHBD Vật lí 12". Nạp sẵn: khung KHBD của trường, PPCT, 1–2 KHBD mẫu đạt chuẩn. Từ đây mọi yêu cầu đều bám đúng khung của bạn, không cần dán lại.' },
          { title: 'Yêu cầu dựng khung 4 hoạt động (CV 5512)', desc: 'Prompt: "Soạn khung KHBD cho bài [tên bài] theo CV 5512, gồm Yêu cầu cần đạt (năng lực + phẩm chất) và 4 hoạt động: Mở đầu – Hình thành kiến thức – Luyện tập – Vận dụng; mỗi hoạt động ghi rõ mục tiêu, nội dung, sản phẩm, tổ chức."' },
          { title: 'Lồng NĂNG LỰC SỐ vào từng hoạt động', desc: 'Yêu cầu AI gắn biểu hiện năng lực số cụ thể: khai thác học liệu số, dùng mô phỏng/công cụ, xử lí dữ liệu, giao tiếp – hợp tác số. Prompt: "Với mỗi hoạt động, bổ sung 1 biểu hiện năng lực số và công cụ số tương ứng."' },
          { title: 'Thêm MẠCH STEM: đo – phân tích – kết luận', desc: 'Yêu cầu chèn một pha thực hành STEM: HS đo bằng cảm biến/điện thoại, phân tích dữ liệu, rút kết luận. Prompt: "Thiết kế 1 hoạt động STEM cho phần Vận dụng theo mạch đo → phân tích dữ liệu → kết luận, nêu rõ dụng cụ và tiêu chí đánh giá."' },
          { title: 'Ép ĐỊNH DẠNG để dán thẳng vào KHBD', desc: 'Yêu cầu đầu ra dạng bảng theo đúng mẫu của trường (cột Hoạt động | Mục tiêu | Nội dung | Sản phẩm | Tổ chức) để copy vào file Word không phải sắp xếp lại.' },
          { title: 'Kiểm & cá nhân hoá', desc: 'Đọc lại, thay ngữ liệu địa phương, chèn thí nghiệm/câu hỏi của mình, chỉnh mức độ cho đúng lớp. Khung là của máy — "hồn" bài dạy là của thầy cô.' },
        ]
      },

      { t: 'h2', c: 'Prompt mẫu (dán 1 lần vào đầu Project)' },
      { t: 'code', c: 'Bạn là giáo viên Vật lí 15 năm, chuyên STEM, soạn KHBD theo CV 5512.\nLuôn: (1) bám Yêu cầu cần đạt của bài; (2) mỗi hoạt động gắn 1 biểu hiện NĂNG LỰC SỐ + công cụ số; (3) phần Vận dụng có 1 pha STEM theo mạch đo–phân tích–kết luận; (4) đầu ra dạng BẢNG: Hoạt động | Mục tiêu | Nội dung | Sản phẩm | Tổ chức.\nGiọng văn sư phạm, ngắn gọn, dùng được ngay.' },
      { t: 'callout', kind: 'warn', c: 'Đừng dán thông tin học sinh (họ tên, điểm, dữ liệu cá nhân) vào công cụ AI công cộng. Chỉ đưa nội dung chuyên môn.' },

      { t: 'h2', c: 'Mẹo nâng cao' },
      { t: 'list', items: [
        'Việc cần logic chặt (ma trận, lời giải nhiều bước) → dùng model suy luận thay vì model thường.',
        'Cho AI 2 KHBD mẫu làm "few-shot" để nó bắt chước đúng văn phong của bạn.',
        'Lưu prompt tốt vào Project để tái dùng — thôi gõ lại mỗi lần.',
      ] },
      { t: 'p', c: 'Làm quen quy trình này, một KHBD có mạch năng lực số và STEM chỉ mất vài phút dựng khung, phần còn lại là bạn thổi hồn vào. Đó là khác biệt giữa "dùng AI" và "có một trợ giảng riêng".' },
    ],
  },
]

export const getArticle = (slug?: string) => ARTICLES.find((a) => a.slug === slug)
